<template>
    <div class="jl-main">
        <div class="jl-main-child">
            <div class="jl-navbar">
                <div class="dd-label flex items-center gap-2 font-mono text-white cursor-pointer"
                    @click="redirectToHomePage">
                    <DecastLogo />
                    <span class="ml-2">Decast</span>
                </div>
            </div>

            <div class="jl-container">
                <!-- Slot where child page content will be injected -->
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>
// import { ref } from 'vue'
import LockImage from '@/decast/components/common/LockImage.vue'
import DecastLogo from '@/decast/icons/DecastLogo.vue';

export default {
    data() {
        return {};
    },
    components: {
        LockImage,
        DecastLogo,
    },
    mounted() {
        document.getElementById('loading-bg-transparent').style.display = 'none';
    },
    methods: {
        redirectToHomePage() {
            this.$router.push('/');
        },
    }
}
</script>

<style scoped>
*:not(i) {
    font-family: 'Rethink Sans' !important;
}

.jl-main {
    height: 100vh;
    width: 100vw;
}

.jl-main-child {
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: #15161F;
}

.jl-navbar {
    padding: 30px 70px;
    width: 100%;
    height: fit-content;
}

.jl-navbar span {
    font-size: 18px;
    font-weight: 500;
}

.jl-container {
    padding: 0px 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}

@media (max-width: 1024px) {}

@media (max-width: 768px) {
    .jl-navbar {
        padding: 20px 50px;
    }

    .jl-container {
        padding: 0px 50px;
    }
}

@media (max-width: 480px) {
    .jl-navbar {
        padding: 20px;
    }

    .jl-container {
        padding: 0px 20px;
    }
}
</style>
